import type {
  FinishOnboarding,
  PostAuthStepUp,
  PostClientOnboardingPriceListExtract,
  PostClientOnboardingProgress,
  Register,
  VerifyTempToken,
} from "@/server-types";
import { post } from "../request-helpers";
import { useCustomMutation } from "../custom-mutation";

/**
 * POST /user/register
 */
export const useRegister = () => {
  return useCustomMutation({
    mutationFn: (body: Register["query"]) =>
      post<Register>("/user/register", body),
  });
};

/**
 * POST /user/onboarding/finish
 */
export const useFinishOnboarding = () => {
  return useCustomMutation({
    mutationFn: (body: FinishOnboarding["body"]) =>
      post<FinishOnboarding>("/user/onboarding/finish", body),
  });
};

/**
 * POST /client/onboarding/progress
 */
export const usePostOnboardingProgress = () => {
  return useCustomMutation({
    mutationFn: (body: PostClientOnboardingProgress["body"]) =>
      post<PostClientOnboardingProgress>("/client/onboarding/progress", body),
  });
};

/**
 * POST /client/onboarding/price-list/extract
 */
export const usePostOnboardingPriceListExtract = () => {
  return useCustomMutation({
    mutationFn: (image: File) => {
      const formData = new FormData();
      formData.append("image", image);

      return post<PostClientOnboardingPriceListExtract>(
        "/client/onboarding/price-list/extract",
        formData,
      );
    },
  });
};

/**
 * POST /verify/token/temp
 */
export const useVerifyTempToken = () => {
  return useCustomMutation({
    mutationFn: (body: VerifyTempToken["query"]) =>
      post<VerifyTempToken>("/verify/token/temp", body),
  });
};

/**
 * POST /user/auth/step-up
 */
export const useAuthStepUp = () => {
  return useCustomMutation({
    mutationKey: ["auth-step-up"],
    mutationFn: (body: PostAuthStepUp["body"]) =>
      post<PostAuthStepUp>("/user/auth/step-up", body),
  });
};
